module.exports = __webpack_public_path__ + "static/media/iphone-hand-touch.35f7b23c.png";